import React from "react";

import AnswerMapping from "./AnswerMapping";
import useTranslations from "../../hooks/useTranslations";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

const SkillMapping: React.FC = () => {
    const t = useTranslations();
  
    useBreadcrumbs([
      {
        to: "/analytics/skill-mapping",
        text: t("statistics.skillMapping") as string,
      },
    ]);
    
    return (
      <AnswerMapping
        title={t("statistics.skillMapping")}
        description={t("statistics.statisticsSkillsDescription")}
        questionTypes={[ "QuestionSkill" ]}
        defaultIsCollaborator={false}
        buildUrl={({ digest }) => `/analytics/skills/${digest}`}
      />
    )
}

export default React.memo(SkillMapping)